export default class SchoolModel {
  constructor(data) {
    if (!data) {
      data = {};
    }

    this.id = data.id || 0;
    this.name = data.name || '';
  }

  get display_name() {
    return this.name;
  }
}
